export default "__VITE_ASSET__BWEGVeD6__"